<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col md="4" align="center" justify="center">
        <div v-if="userIsAuthenticated">
          <transition appear name="fade" mode="out-in"> 
            <div>
              <v-icon x-large>mdi-account-box-outline</v-icon>
              <p class="mb-5 mt-5">{{ user.email }}</p>
              <v-card class="mx-auto" max-width="220">
                <v-list  rounded>
                  <v-list-item to="/meetups/new">
                    <v-list-item-content>
                      <v-list-item-title>Добавить запись</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item to="/slides/new">
                    <v-list-item-content>
                      <v-list-item-title>Добавить слайд</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="signOut">
                    <v-list-item-content>
                      <v-list-item-title class="red--text font-weight-bold">Выйти</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
          </transition>
        </div>
        <v-form v-else>
          <transition appear name="fade" mode="out-in"> 
            <div>
            <v-card>

              <v-toolbar dark color="success">
                <v-toolbar-title>
                  Авторизация
                </v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-text-field
                  name="email"
                  label="E-mail"
                  type="text"
                  prepend-icon="mdi-account"
                  v-model="email"
                  :rules="[v => !!v || 'введите e-mail']"
                >
                </v-text-field>
                <v-text-field
                  name="password"
                  label="Пароль"
                  type="password"
                  prepend-icon="mdi-lock"
                  v-model="password"
                  :rules="[v => !!v || 'введите пароль']"
                >
                </v-text-field>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" :loading="loadingStatus" :disabled="loadingStatus" @click="onSignIn" >
                  Войти
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </v-card-actions>

            </v-card>
            </div>
          </transition>
        </v-form>
      </v-col>


      <v-snackbar v-model="snackbar" v-if="errorText">
          {{ errorText }}
          <v-btn color="pink" @click="snackbar = !snackbar">ok</v-btn>
      </v-snackbar>

    </v-row>
  </v-container>
</template>

<script>

  export default {
    data: () => ({
      email: '',
      password: '',
      snackbar: false
    }),
    computed: {
      user(){
        return this.$store.getters.user;
      },
      userIsAuthenticated(){
        this.$store.dispatch('userIsAuthenticated');
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
      },
      errorText(){
        return this.$store.getters.error;
      },
      loadingStatus(){
        return this.$store.state.loading;
      }
    },
    methods: {
      onSignIn() {
        this.$store.dispatch('signInUser', {
          email: this.email,
          password: this.password,
        });
      },
      signOut(){
        this.$store.dispatch('signOutUser');
      }
    },
    watch: {
      errorText: function(){
        this.snackbar = true
      }
    }

  }

</script>


<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>